import { useMutation } from "react-query";
import { updateOrderTable } from "../../../services/inventory";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { platformHandler, ToastContext } from "../../../hooks/context";
import { getPlatform } from "../../../helpers";
import { useGetUserList } from "../../../hooks/api/queries/useSettings";

export const useEditOrderTableForm = ({ tableDetails, storeList }) => {
  const reLabelDefault = (menus, nameKey = "last_name", idKey = "id") => {
    let newArray = [];
    menus?.forEach((menu) => {
      newArray?.push({
        value: menu?.[idKey],
        label: menu?.[nameKey],
      });
    });
    return newArray;
  };
  const [formData, setFormData] = useState(tableDetails);
  const [isEditStore, setIsEditStore] = useState(false);
  const [isUsers, setUsers] = useState(
    tableDetails?.users ? reLabelDefault(tableDetails?.users) : [],
  );
  const { platform } = useContext(platformHandler);
  const navigate = useNavigate();
  const triggerToast = useContext(ToastContext);

  const serializeStore = (store) => {
    const _store = storeList.find(({ id }) => id === store);
    return _store?.id;
  };

  const { mutate: updateTable, isLoading: isUpdatingOrderTable } = useMutation(
    (data) => updateOrderTable(data),
  );

  const submitTableDetails = () => {
    updateTable(
      {
        name: formData?.name,
        table_id: formData?.id,
        store: isEditStore ? formData.store : serializeStore(formData?.store),
        seat_capacity: formData?.seat_capacity,
        users: isUsers.every(
          (item) => typeof item === "number" || typeof item === "string",
        )
          ? isUsers
          : isUsers?.map((user) => user?.value),
      },
      {
        onSuccess: () => {
          navigate(getPlatform(platform) + "/inventory/tables");
          triggerToast("Table successfully updated", "success");
        },
      },
    );
  };

  const {
    isLoading: isFetchingUsers,
    data: users,
    refetch: fetchUsersList,
  } = useGetUserList();

  return {
    formData,
    isUpdatingOrderTable,
    isEditStore,
    setFormData,
    submitTableDetails,
    setIsEditStore,
    isFetchingUsers,
    users,
    fetchUsersList,
    isUsers,
    setUsers,
  };
};
